import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ComplementaryData } from './ComplementaryData';
import { ProgressCircle, ProgressContainer, ValueCircle, WheelChartWrapper } from './subcomponents';
var WheelChart = function (_a) {
    var currentPointsValue = _a.currentPointsValue, currentPointsText = _a.currentPointsText;
    var degreeValue = useMemo(function () { return Math.round((currentPointsValue / 1000) * 360); }, [currentPointsValue]);
    return (_jsxs(WheelChartWrapper, { children: [_jsxs(ProgressContainer, { children: [_jsx(ProgressCircle, { "data-testid": "PieChart", "data-cy": "progress-circle" }), _jsx(ValueCircle, { degreeValue: degreeValue, "data-testid": "ValueCircle", "data-cy": "value-circle" })] }), _jsx(ComplementaryData, { currentPointsValue: currentPointsValue, currentPointsText: currentPointsText })] }));
};
export default WheelChart;
